import { css } from '@emotion/react';

const RESOURCE_CARD_GAP = '24px';

export const list = css`
  display: grid;
  align-items: stretch;
  gap: ${RESOURCE_CARD_GAP};
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
`;

export const emptyStateContainer = css`
  padding-top: 30px;
  height: 100%;
`;

export const loader = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
`;
